<ng-container [ngSwitch]="size">
  <h1 class="title" [ngClass]="classList" [class.title--disabled]="disabled" *ngSwitchCase="'h1'">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h1>
  <h2 class="title" [ngClass]="classList" [class.title--disabled]="disabled" *ngSwitchCase="'h2'">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h2>
  <h3 class="title" [ngClass]="classList" [class.title--disabled]="disabled" *ngSwitchCase="'h3'">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h3>
  <h4 class="title" [ngClass]="classList" [class.title--disabled]="disabled" *ngSwitchCase="'h4'">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h4>
  <h5 class="title" [ngClass]="classList" [class.title--disabled]="disabled" *ngSwitchCase="'h5'">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h5>
  <h6 class="title" [ngClass]="classList" [class.title--disabled]="disabled" *ngSwitchCase="'h6'">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h6>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
